import {
    http,
    Header,
    ContentType,
    qs,
    GetFormData,
    StatusCode,
    Global,
    Method
} from './api-util';

export const recordPddGoods = (goodsId) => {
    return http({
        method: Method.PUT,
        url: Global.BASE_URL + "/pdd/record/goods",
        data: {
            goodsId
        }
    }).then(res => res.data)
}

export const record = () => {
    return http({
        method: Method.PUT,
        url: Global.BASE_URL + "/pdd/record"
    }).then(res => res.data)
}